export default __webpack_public_path__ + "static/media/04_DAIF_Infra_03_01-end.58101542.jpg";